import { UserAttendanceMyRequestsLoading } from '@/views/user-attendance-my-requests';

export default UserAttendanceMyRequestsLoading;
